export default (state =
    {
        loading: true,
        error: null,
        data: []
    }
, action) => {
    switch (action.type) {

        case 'GET_ALL_ADMIN_VIEWS_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                data: []
            };

        case 'GET_ALL_ADMIN_VIEWS_SUCCESS':
            return {
                data: action.payload.data.data,
                loading: false,
                error: null,
            };

        case 'GET_ALL_ADMIN_VIEWS_FAILURE':
            return {
                data: [],
                loading: false,
                error: true,
                message: action.payload.response.data.message,
                userMessage: action.payload.response.data['usermessage'],
            };

        default:
            return state;

    }

};